import Vue from 'vue';
import Component from 'vue-class-component';
import Datepicker from 'vuejs-datepicker';
import dayjs from 'dayjs';

@Component({
  components: { Datepicker },
})
export default class DateTimePickerComponent extends Vue {
  dateRanges = {
    to: dayjs().add(2, 'day').toDate(),
  };
  showCalendar = false;
  date = null;
  dateFormatted = null;
  currentClock = {
    hour: 9,
    minutes: 30,
    timePeriod: 'AM',
  };
  prevClock = {
    hour: 9,
    minutes: 15,
    timePeriod: 'AM',
  };
  maxTime = {
    hour: 12,
    minutes: 0,
    timePeriod: 'AM',
  };
  minTime = {
    hour: 8,
    minutes: 0,
    timePeriod: 'AM',
  };

  get currentTime() {
    return this.formatTime(this.currentClock);
  }

  get prevTime() {
    return this.formatTime(this.prevClock);
  }

  toggleCalendar() {
    this.showCalendar = !this.showCalendar;
  }

  setDate() {
    this.dateFormatted = dayjs(this.date).format('DD/MM/YYYY');
    this.toggleCalendar();
  }

  formatTime(clock) {
    if (clock.minutes === 0) {
      return `${clock.hour}:${clock.minutes}0 ${clock.timePeriod}`;
    }
    return `${clock.hour}:${clock.minutes} ${clock.timePeriod}`;
  }

  checkTimeLimit(clock, limit) {
    const clockArr = Object.values(clock);
    const limitArr = Object.values(limit);
    return clockArr.every((value, i) => {
      return value === limitArr[i];
    });
  }

  checkTimePeriod(clock, limit) {
    if (clock.hour === limit && clock.timePeriod === 'AM') {
      clock.timePeriod = 'PM';
    } else if (clock.hour === limit && clock.timePeriod === 'PM') {
      clock.timePeriod = 'AM';
    }
  }

  increaseTime() {
    if (this.checkTimeLimit(this.currentClock, this.maxTime)) {
      return;
    }
    this.prevClock.hour = this.currentClock.hour;
    this.prevClock.minutes = this.currentClock.minutes;
    this.prevClock.timePeriod = this.currentClock.timePeriod;
    if (this.currentClock.minutes + 15 === 60) {
      this.currentClock.minutes = 0;
      if (this.currentClock.hour + 1 === 13) {
        this.currentClock.hour = 1;
      } else {
        this.currentClock.hour = this.currentClock.hour + 1;
      }
      this.checkTimePeriod(this.currentClock, 12);
    } else {
      this.currentClock.minutes = this.currentClock.minutes + 15;
    }
  }

  decreaseTime() {
    if (this.checkTimeLimit(this.currentClock, this.minTime)) {
      return;
    }
    this.currentClock.hour = this.prevClock.hour;
    this.currentClock.minutes = this.prevClock.minutes;
    this.currentClock.timePeriod = this.prevClock.timePeriod;
    if (this.prevClock.minutes - 15 === -15) {
      this.prevClock.minutes = 45;
      if (this.prevClock.hour - 1 === 0) {
        this.prevClock.hour = 12;
      } else {
        this.prevClock.hour = this.prevClock.hour - 1;
      }
      this.checkTimePeriod(this.prevClock, 11);
    } else {
      this.prevClock.minutes = this.prevClock.minutes - 15;
    }
  }
}
